module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('custom-table', {
    attrs: {
      "edit": "/undertakers/{:id}",
      "criteria": _vm.criteria,
      "add": "/undertakers/new",
      "default-sort": _vm.defSort,
      "search": "",
      "src-model": _vm.$store.getters.models('undertakers'),
      "cols": _vm.cols
    },
    on: {
      "print": _vm.print
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Übersicht der Bestatter")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ba82c1b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UndertakerOverview.vue
// module id = 435
// module chunks = 0